const MERCHANT_STATUSES = {
  inactive: { name: "inactive", id: "inactive" },
  active: { name: "active", id: "active" },
  blocked: { name: "blocked", id: "blocked" },
  disabled: { name: "disabled", id: "disabled" },
};

export default MERCHANT_STATUSES;
